<template>
  <div class="singup-company">
    <h1>Iniciar sesión</h1>
    <div class="input-content full-input label-top">
      <label for="email">Correo electrónico</label>
      <input type="text" value="" name="email" />
      <label for="password">Contraseña</label>
      <input type="password" value="" name="password" />
    </div>
    <input class="submit" type="submit" value="Iniciar sesión" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.singup-company {
  text-align: left;
  h1 {
    text-align: center;
  }
  .information {
    display: flex;
    width: 100%;
    .information-content {
      width: 50%;
    }
  }
  input {
    width: 100%;
    margin-bottom: 30px;
    border: 1px solid #d0d0d0;
    height: 70px;
    border-radius: 35px;
    padding: 20px 30px;
    &:focus {
      border-color: #222ac3;
    }
  }
  .label-top {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .submit {
    background: #222ac3;
    color: white;
    font-size: 15px;
    font-family: Poppins;
  }
}
</style>
